import { InputNumber } from 'component/Input/InputNumber'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { store } from 'store/store'

type Props = {
  type: 'min' | 'max'
}

export const PriceInput = observer(({ type }: Props) => {
  const rec = store.item!.rec
  const price = type === 'min' ? rec.min_price : rec.max_price
  const title = type === 'min' ? i18n('MinPrice') : i18n('MaxPrice')

  const onChange = useLatestCallback((value: number | undefined) => {
    price.raw = value
  })

  const before = <Typo tertiary>{title}</Typo>

  return <InputNumber value={price.raw} onChange={onChange}
    height={40} borderless panel clear before={before} />
})
